import { render, staticRenderFns } from "./RelatorioRh.vue?vue&type=template&id=4602950b&"
import script from "./RelatorioRh.vue?vue&type=script&lang=js&"
export * from "./RelatorioRh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports